import { render, staticRenderFns } from "./qiyeXiangqing.vue?vue&type=template&id=a9071a38&scoped=true&"
import script from "./qiyeXiangqing.vue?vue&type=script&lang=js&"
export * from "./qiyeXiangqing.vue?vue&type=script&lang=js&"
import style0 from "./qiyeXiangqing.vue?vue&type=style&index=0&id=a9071a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9071a38",
  null
  
)

export default component.exports